var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGridActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 20,
    rx: 4,
    fill: "#DD5E27"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 9.5625V4.75H10.5625V9.5625H5.75ZM5.75 15.25V10.4375H10.5625V15.25H5.75ZM11.4375 9.5625V4.75H16.25V9.5625H11.4375ZM11.4375 15.25V10.4375H16.25V15.25H11.4375ZM6.625 8.6875H9.6875V5.625H6.625V8.6875ZM12.3125 8.6875H15.375V5.625H12.3125V8.6875ZM12.3125 14.375H15.375V11.3125H12.3125V14.375ZM6.625 14.375H9.6875V11.3125H6.625V14.375Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridActive);
export default __webpack_public_path__ + "static/media/GridActive.ced75a36b27f399ebc8cf4ee711e89c8.svg";
export { ForwardRef as ReactComponent };